/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Accessible_SemanticInputs */

const en_a11y_statement_accessible_semantic = /** @type {(inputs: A11y_Statement_Accessible_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semantic HTML structure in resumes and cover letters`)
};

const de_a11y_statement_accessible_semantic = /** @type {(inputs: A11y_Statement_Accessible_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semantische HTML-Struktur in Lebensläufen und Anschreiben`)
};

const fr_a11y_statement_accessible_semantic = /** @type {(inputs: A11y_Statement_Accessible_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Structure HTML semantique dans les CV et lettres de motivation`)
};

const es_a11y_statement_accessible_semantic = /** @type {(inputs: A11y_Statement_Accessible_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estructura HTML semantica en curriculos y cartas de presentacion`)
};

const it_a11y_statement_accessible_semantic = /** @type {(inputs: A11y_Statement_Accessible_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Struttura HTML semantica nei CV e nelle lettere di presentazione`)
};

const nl_a11y_statement_accessible_semantic = /** @type {(inputs: A11y_Statement_Accessible_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semantische HTML-structuur in cv's en motivatiebrieven`)
};

const pl_a11y_statement_accessible_semantic = /** @type {(inputs: A11y_Statement_Accessible_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semantyczna struktura HTML w CV i listach motywacyjnych`)
};

const fi_a11y_statement_accessible_semantic = /** @type {(inputs: A11y_Statement_Accessible_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semanttinen HTML-rakenne ansioluetteloissa ja saatekirjeissä`)
};

const da_a11y_statement_accessible_semantic = /** @type {(inputs: A11y_Statement_Accessible_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semantisk HTML-struktur i CV'er og ansogninger`)
};

const sv_a11y_statement_accessible_semantic = /** @type {(inputs: A11y_Statement_Accessible_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semantisk HTML-struktur i CV:n och personliga brev`)
};

/**
* | output |
* | --- |
* | "Semantic HTML structure in resumes and cover letters" |
*
* @param {A11y_Statement_Accessible_SemanticInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_accessible_semantic = /** @type {((inputs?: A11y_Statement_Accessible_SemanticInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Accessible_SemanticInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_accessible_semantic(inputs)
	if (locale === "fr") return fr_a11y_statement_accessible_semantic(inputs)
	if (locale === "es") return es_a11y_statement_accessible_semantic(inputs)
	if (locale === "it") return it_a11y_statement_accessible_semantic(inputs)
	if (locale === "nl") return nl_a11y_statement_accessible_semantic(inputs)
	if (locale === "pl") return pl_a11y_statement_accessible_semantic(inputs)
	if (locale === "fi") return fi_a11y_statement_accessible_semantic(inputs)
	if (locale === "da") return da_a11y_statement_accessible_semantic(inputs)
	if (locale === "sv") return sv_a11y_statement_accessible_semantic(inputs)
	return en_a11y_statement_accessible_semantic(inputs)
});